import { FourSquare } from "react-loading-indicators";

type Props = {
  show: boolean;
  opacity?: number;
};

export default function GlobalLoading({ show, opacity }: Props) {
  if (!show) return null;

  return (
    <div
      className={`fixed inset-0 bg-white ${
        opacity ? `bg-opacity-${opacity}` : "bg-opacity-40"
      } flex items-center justify-center z-50`}
    >
      <FourSquare
        color={["#32cd32", "#327fcd", "#cd32cd", "#cd8032"]}
        size="medium"
      />
    </div>
  );
}
